import { render, staticRenderFns } from "./MapIntensityPolygons.component.vue?vue&type=template&id=38fe19a5&scoped=true"
import script from "./MapIntensityPolygons.component.vue?vue&type=script&lang=ts"
export * from "./MapIntensityPolygons.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fe19a5",
  null
  
)

export default component.exports